export const colorSelect = (headerId: string) => {
  // console.log("headerId", headerId, headerId.startsWith("P_"));
  if (
    headerId.startsWith("PT_") ||
    headerId.startsWith("PTC_") ||
    headerId.startsWith("PTS_")
  ) {
    return "processPt";
  } else if (
    headerId.startsWith("PV_") ||
    headerId.startsWith("PVC_") ||
    headerId.startsWith("PVS_")
  ) {
    return "processPv";
  } else if (headerId.startsWith("S_")) {
    return "site";
  } else {
    return "base";
  }
};

export const colorSelectRuturnCode = (headerId: string) => {
  // console.log("headerId", headerId, headerId.startsWith("P_"));
  if (
    headerId.startsWith("PT_") ||
    headerId.startsWith("PTC_") ||
    headerId.startsWith("PTS_")
  ) {
    return "#09A0F2";
  } else if (
    headerId.startsWith("PV_") ||
    headerId.startsWith("PVC_") ||
    headerId.startsWith("PVS_")
  ) {
    return "#FF5ECD";
  } else if (headerId.startsWith("S_")) {
    return "#ffdb5e";
  } else {
    return "#0adcc0";
  }
};

export const colorSelectRuturnCodeLite = (headerId: string) => {
  // console.log("headerId", headerId, headerId.startsWith("P_"));
  if (
    headerId.startsWith("PT_") ||
    headerId.startsWith("PTC_") ||
    headerId.startsWith("PTS_")
  ) {
    return "#255dcd";
  } else if (
    headerId.startsWith("PV_") ||
    headerId.startsWith("PVC_") ||
    headerId.startsWith("PVS_")
  ) {
    return "#d9087f";
  } else if (headerId.startsWith("S_")) {
    return " #f3bf06";
  } else {
    return "#058473";
  }
};
